import { NgClass, NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";

@Component({
  selector: "app-perks-and-benefits",
  templateUrl: "./perks-and-benefits.component.html",
  styleUrls: ["./perks-and-benefits.component.scss"],
  imports: [NgClass, NgOptimizedImage],
})
export class PerksAndBenefitsComponent {
  public readonly threeColumnsGrid = input(false);
}
